import axios from 'axios'

export const getDrivers = ({ serialNumber }) => {
    return axios({
        url: `https://rma.getac.com/WEB/biosDriverAction.do?method=getFilesBySn&serial_number=${serialNumber}`,
        method: `get`
    })
}
